import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import AuthLayout, { Field } from "./AuthLayout";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back${u?.name ? ", " + u.name.split(" ")[0] : ""}!`);
      if (u?.role === "super_admin") nav("/admin");
      else if (!u?.business_id) nav("/onboarding");
      else nav(loc.state?.from || "/app");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Login failed");
    }
    setLoading(false);
  };

  return (
    <AuthLayout title="Sign in" subtitle="Welcome back to your workspace"
      footer={<>New to Amden One? <Link to="/register" className="text-blue-accent font-semibold">Create a free account</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="you@business.com" />
        <Field label="Password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="••••••••" />
        <div className="flex justify-end">
          <Link to="/forgot-password" className="text-sm text-blue-accent hover:underline" data-testid="forgot-link">Forgot password?</Link>
        </div>
        <button disabled={loading} data-testid="login-submit" className="w-full px-5 py-3 rounded-xl bg-navy hover:bg-slate-800 text-white font-semibold transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-4 text-xs text-slate-400">Demo owner: daniel@amden.ie · Cayden2008!</p>
    </AuthLayout>
  );
}
